export type ITabs = {
  tabs: Array<ITabsValue>;
  callBack: (id: string, name: string) => void;
  selectedTab: ITabsValue;
};

export type ITabsValue = {
  name: string;
  id: string;
};

export type IUnitLevelLabels = {
  unitID: string;
  floorplanID: string;
  propertyCode: string;
  bestOfferTerm: string;
  twelveMonthPrice: string;
  mostRecent12MonthPrice: string;
  marketRent: string;
  beds: string;
  baths: string;
  sqft: string;
  strategy: string;
  isOccupied: string;
};

export type IUnitLevelItems = Array<IUnitLevelItem>;

export type IUnitLevelItem = {
  id: number;
  UnitId: string;
  UnitType: string;
  Property_Code: string;
  StalenessFactor: number;
  MarketRent: number;
  AvailableDate: string;
  Bedrooms: number;
  Bathrooms: number;
  Sqft: number;
  HasAmenities: boolean;
  Status: string;
  BestOfferTerm: number;
  BestOfferPrice: number;
  TwelveMonthTerm: number;
  TwelveMonthPrice: number;
  LastRent: number;
  LastLeaseToDate: string;
  LastLeaseFromDate: string;
  IsAvailable: false;
  RecentMoveoutDate: string;
  DaysVacant: number;
  IsApproved: boolean;
  IsExcluded: boolean;
  IsFlagged: boolean;
  IsUploaded: boolean;
  Strategy: string;
  // amenities: Array<string>;
  priceMatrices?: {
    offers: any;
    prices: Array<Array<string>>;
    terms: Array<string>;
    bestPrices: Array<string>;
    dates: Array<string>;
  };
  FlagItem?: any;
  // status: {
  //   editMode: true;
  //   isApproved: boolean;
  //   isExcluded: boolean;
  //   isFlagged: boolean;
  //   flagItem: any;
  // };
};

export const sortByNames = {
  BEDS: 'beds',
  BATHS: 'baths',
  SQFT: 'Sqft',
  DaysVacant: 'daysVacant',
  OccupiedUnits: 'occupiedUnits',
  AvailableUnits: 'availableUnits',
  BEDROOMS: 'Beds',
};
